import { Component, createEffect, onMount } from "solid-js";
import { CampaignTile } from "@/types/checkout";
import { FsTooltip } from "@cof/fs-tooltip-wc";

interface CampaignTileButtonProps {
  tile: CampaignTile;
  isSelected: boolean;
  isDisabled: boolean;
  tooltipText?: string;
  onChange: (isNowSelected: boolean) => void;
}

const CampaignTileButton: Component<CampaignTileButtonProps> = (props) => {
  let tooltipRef: FsTooltip | undefined;

  const handleChange = (e: Event) => {
    const target = e.target as HTMLInputElement & { selected: boolean };
    const wantsToSelect = target.selected ?? target.checked;
    props.onChange(wantsToSelect);
  };

  const updateTooltipVisibility = (text: string | undefined) => {
    if (!tooltipRef) return;
    const tooltipDiv = tooltipRef.tooltipElement;
    if (tooltipDiv) {
      tooltipDiv.style.display = text ? "" : "none";
    }
  };

  onMount(() => {
    // Wait for Lit's first render cycle before hiding the empty tooltip
    requestAnimationFrame(() => updateTooltipVisibility(props.tooltipText));
  });

  createEffect(() => {
    updateTooltipVisibility(props.tooltipText);
  });

  return (
    <fd-mfe-tooltip
      ref={tooltipRef}
      prop:tooltipContent={props.tooltipText ?? ""}
      prop:position="top"
    >
      <fd-mfe-choice-button
        prop:labelText={props.tile.month}
        prop:subtext={props.tile.subtext}
        prop:disabled={props.isDisabled}
        prop:selected={props.isSelected}
        prop:type="checkbox"
        prop:size="medium"
        prop:value={props.tile.id}
        class="min-h-FsSizing9x @xs:min-h-FsSizing16x"
        on:change={handleChange}
        data-testid="campaign-month-tile"
      />
    </fd-mfe-tooltip>
  );
};

export default CampaignTileButton;
